// src/common/components/HandleCell/HandleCell.tsx

import React from 'react';
import { Handle } from '@/common/components/Handle/Handle.tsx';
import { useSortable } from "@dnd-kit/sortable";
import clsx from "clsx";
import { NO_SELECTO_CLASSNAME } from "@/types/types.ts";
import useCurrentExplorerItemId from "@/common/hooks/useCurrentExplorerItemId.ts";
import styles from './Sortable.module.scss';

interface HandleCellProps {
  id: string;
  disabled?: boolean;
}

export const HandleCell: React.FC<HandleCellProps> = ({ id, disabled = false }) => {
  const [currentExplorerItemId] = useCurrentExplorerItemId();
  const {
    attributes,
    listeners,
    setNodeRef,
  } = useSortable({ id });

  return (
    <div
      ref={setNodeRef}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%'
      }}
    >
      <Handle
        className={
          clsx({
            [styles.handleCurrentItem]: currentExplorerItemId === id,
            [styles.handle]: !disabled,
            ['dragHandle']: true,
            [NO_SELECTO_CLASSNAME]: true,
            [styles.handleDisabled]: disabled,
          })
        }
        {...attributes}
        {...listeners}
      />
    </div>
  );
};
